// import React from 'react'

// const OrderDetail = () => {
//   return (
//   <div className="page-content">
//   {/* Start Container */}
//   <div className="container-fluid">
//     {/* ========== Page Title Start ========== */}
//     <div className="row">
//       <div className="col-12">
//         <div className="page-title-box">
//           <h4 className="mb-0 fw-semibold">Order Details</h4>
//           <ol className="breadcrumb mb-0">
//             <li className="breadcrumb-item">
//               <a href="javascript: void(0);">Order</a>
//             </li>
//             <li className="breadcrumb-item active">Order Details</li>
//           </ol>
//         </div>
//       </div>
//     </div>
//     {/* ========== Page Title End ========== */}
//     <div className="row">
//       <div className="col-xl-9 col-lg-8">
//         <div className="row">
//           <div className="col-lg-12">
//             <div className="card">
//               <div className="card-body">
//                 <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
//                   <div>
//                     <h4 className="fw-medium text-dark d-flex align-items-center gap-2">
//                       #0758267/90{" "}
//                       <span className="badge bg-success-subtle text-success  px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                       <span className="border border-warning text-warning fs-13 px-2 py-1 rounded">
//                         In Progress
//                       </span>
//                     </h4>
//                     <p className="mb-0">
//                       Order / Order Details / #0758267/90 - April 23 , 2024 at
//                       6:23 pm
//                     </p>
//                   </div>
//                   <div>
//                     <a href="#!" className="btn btn-outline-secondary">
//                       Refund
//                     </a>
//                     <a href="#!" className="btn btn-outline-secondary">
//                       Return
//                     </a>
//                     <a href="#!" className="btn btn-primary">
//                       Edit Order
//                     </a>
//                   </div>
//                 </div>
//                 <div className="mt-4">
//                   <h4 className="fw-medium text-dark">Progress</h4>
//                 </div>
//                 <div className="row row-cols-xxl-5 row-cols-md-2 row-cols-1">
//                   <div className="col">
//                     <div className="progress mt-3" style={{ height: 10 }}>
//                       <div
//                         className="progress-bar progress-bar  progress-bar-striped progress-bar-animated bg-success"
//                         role="progressbar"
//                         style={{ width: "100%" }}
//                         aria-valuenow={70}
//                         aria-valuemin={0}
//                         aria-valuemax={70}
//                       ></div>
//                     </div>
//                     <p className="mb-0 mt-2">Order Confirming</p>
//                   </div>
//                   <div className="col">
//                     <div className="progress mt-3" style={{ height: 10 }}>
//                       <div
//                         className="progress-bar progress-bar  progress-bar-striped progress-bar-animated bg-success"
//                         role="progressbar"
//                         style={{ width: "100%" }}
//                         aria-valuenow={70}
//                         aria-valuemin={0}
//                         aria-valuemax={70}
//                       ></div>
//                     </div>
//                     <p className="mb-0 mt-2">Payment Pending</p>
//                   </div>
//                   <div className="col">
//                     <div className="progress mt-3" style={{ height: 10 }}>
//                       <div
//                         className="progress-bar progress-bar  progress-bar-striped progress-bar-animated bg-warning"
//                         role="progressbar"
//                         style={{ width: "60%" }}
//                         aria-valuenow={70}
//                         aria-valuemin={0}
//                         aria-valuemax={70}
//                       ></div>
//                     </div>
//                     <div className="d-flex align-items-center gap-2 mt-2">
//                       <p className="mb-0">Processing</p>
//                       <div
//                         className="spinner-border spinner-border-sm text-warning"
//                         role="status"
//                       >
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col">
//                     <div className="progress mt-3" style={{ height: 10 }}>
//                       <div
//                         className="progress-bar progress-bar  progress-bar-striped progress-bar-animated bg-primary"
//                         role="progressbar"
//                         style={{ width: "0%" }}
//                         aria-valuenow={70}
//                         aria-valuemin={0}
//                         aria-valuemax={70}
//                       ></div>
//                     </div>
//                     <p className="mb-0 mt-2">Shipping</p>
//                   </div>
//                   <div className="col">
//                     <div className="progress mt-3" style={{ height: 10 }}>
//                       <div
//                         className="progress-bar progress-bar  progress-bar-striped progress-bar-animated bg-primary"
//                         role="progressbar"
//                         style={{ width: "0%" }}
//                         aria-valuenow={70}
//                         aria-valuemin={0}
//                         aria-valuemax={70}
//                       ></div>
//                     </div>
//                     <p className="mb-0 mt-2">Delivered</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="card-footer d-flex flex-wrap align-items-center justify-content-between bg-light-subtle gap-2">
//                 <p className="border rounded mb-0 px-2 py-1 bg-body">
//                   <i className="bx bx-arrow-from-left align-middle fs-16" />
//                   Estimated shipping date :{" "}
//                   <span className="text-dark fw-medium">Apr 25 , 2024</span>
//                 </p>
//                 <div>
//                   <a href="#!" className="btn btn-primary">
//                     Make As Ready To Ship
//                   </a>
//                 </div>
//               </div>
//             </div>
//             <div className="card">
//               <div className="card-header">
//                 <h4 className="card-title">Product</h4>
//               </div>
//               <div className="card-body">
//                 <div className="table-responsive">
//                   <table className="table align-middle mb-0 table-hover table-centered">
//                     <thead className="bg-light-subtle border-bottom">
//                       <tr>
//                         <th>Product Name &amp; Size</th>
//                         <th>Status</th>
//                         <th>Quantity</th>
//                         <th>Price</th>
//                         <th>Text</th>
//                         <th>Amount</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
//                               <img
//                                 src="/images/product/p-1.png"
//                                 alt=""
//                                 className="avatar-md"
//                               />
//                             </div>
//                             <div>
//                               <a
//                                 href="#!"
//                                 className="text-dark fw-medium fs-15"
//                               >
//                                 Men Black Slim Fit T-shirt
//                               </a>
//                               <p className="text-muted mb-0 mt-1 fs-13">
//                                 <span>Size : </span>M
//                               </p>
//                             </div>
//                           </div>
//                         </td>
//                         <td>
//                           <span className="badge bg-success-subtle text-success  px-2 py-1 fs-13">
//                             Ready
//                           </span>
//                         </td>
//                         <td> 1</td>
//                         <td>$80.00</td>
//                         <td> $3.00</td>
//                         <td>$83.00</td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
//                               <img
//                                 src="/images/product/p-5.png"
//                                 alt=""
//                                 className="avatar-md"
//                               />
//                             </div>
//                             <div>
//                               <a
//                                 href="#!"
//                                 className="text-dark fw-medium fs-15"
//                               >
//                                 Dark Green Cargo Pent
//                               </a>
//                               <p className="text-muted mb-0 mt-1 fs-13">
//                                 <span>Size : </span>M
//                               </p>
//                             </div>
//                           </div>
//                         </td>
//                         <td>
//                           <span className="badge bg-light text-dark  px-2 py-1 fs-13">
//                             Packaging
//                           </span>
//                         </td>
//                         <td> 3</td>
//                         <td>$330.00</td>
//                         <td> $4.00</td>
//                         <td>$334.00</td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
//                               <img
//                                 src="/images/product/p-8.png"
//                                 alt=""
//                                 className="avatar-md"
//                               />
//                             </div>
//                             <div>
//                               <a
//                                 href="#!"
//                                 className="text-dark fw-medium fs-15"
//                               >
//                                 Men Dark Brown Wallet
//                               </a>
//                               <p className="text-muted mb-0 mt-1 fs-13">
//                                 <span>Size : </span>S
//                               </p>
//                             </div>
//                           </div>
//                         </td>
//                         <td>
//                           <span className="badge bg-success-subtle text-success  px-2 py-1 fs-13">
//                             Ready
//                           </span>
//                         </td>
//                         <td> 1</td>
//                         <td>$132.00</td>
//                         <td> $5.00</td>
//                         <td>$137.00</td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
//                               <img
//                                 src="/images/product/p-10.png"
//                                 alt=""
//                                 className="avatar-md"
//                               />
//                             </div>
//                             <div>
//                               <a
//                                 href="#!"
//                                 className="text-dark fw-medium fs-15"
//                               >
//                                 Kid's Yellow T-shirt
//                               </a>
//                               <p className="text-muted mb-0 mt-1 fs-13">
//                                 <span>Size : </span>S
//                               </p>
//                             </div>
//                           </div>
//                         </td>
//                         <td>
//                           <span className="badge bg-light text-dark  px-2 py-1 fs-13">
//                             Packaging
//                           </span>
//                         </td>
//                         <td> 2</td>
//                         <td>$220.00</td>
//                         <td> $3.00</td>
//                         <td>$223.00</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//             <div className="card">
//               <div className="card-header">
//                 <h4 className="card-title">Order Timeline</h4>
//               </div>
//               <div className="card-body">
//                 <div className="position-relative ms-2">
//                   <span className="position-absolute start-0  top-0 border border-dashed h-100" />
//                   <div className="position-relative ps-4">
//                     <div className="mb-4">
//                       <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle">
//                         <div
//                           className="spinner-border spinner-border-sm text-warning"
//                           role="status"
//                         >
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                       </span>
//                       <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
//                         <div>
//                           <h5 className="mb-1 text-dark fw-medium fs-15">
//                             The packing has been started
//                           </h5>
//                           <p className="mb-0">Confirmed by Gaston Lapierre</p>
//                         </div>
//                         <p className="mb-0">April 23, 2024, 09:40 am</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="position-relative ps-4">
//                     <div className="mb-4">
//                       <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
//                         <i className="bx bx-check-circle" />
//                       </span>
//                       <div className="ms-2 d-flex flex-wrap gap-2  align-items-center justify-content-between">
//                         <div>
//                           <h5 className="mb-1 text-dark fw-medium fs-15">
//                             The Invoice has been sent to the customer
//                           </h5>
//                           <p className="mb-2">
//                             Invoice email was sent to{" "}
//                             <a href="#!" className="link-primary">
//                               hello@dundermuffilin.com
//                             </a>
//                           </p>
//                           <a href="#!" className="btn btn-light">
//                             Resend Invoice
//                           </a>
//                         </div>
//                         <p className="mb-0">April 23, 2024, 09:40 am</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="position-relative ps-4">
//                     <div className="mb-4">
//                       <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
//                         <i className="bx bx-check-circle" />
//                       </span>
//                       <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
//                         <div>
//                           <h5 className="mb-1 text-dark fw-medium fs-15">
//                             The Invoice has been created
//                           </h5>
//                           <p className="mb-2">
//                             Invoice created by Gaston Lapierre
//                           </p>
//                           <a href="#!" className="btn btn-primary">
//                             Download Invoice
//                           </a>
//                         </div>
//                         <p className="mb-0">April 23, 2024, 09:40 am</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="position-relative ps-4">
//                     <div className="mb-4">
//                       <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
//                         <i className="bx bx-check-circle" />
//                       </span>
//                       <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
//                         <div>
//                           <h5 className="mb-1 text-dark fw-medium fs-15">
//                             Order Payment
//                           </h5>
//                           <p className="mb-2">Using Master Card</p>
//                           <div className="d-flex align-items-center gap-2">
//                             <p className="mb-1 text-dark fw-medium">Status :</p>
//                             <span className="badge bg-success-subtle text-success  px-2 py-1 fs-13">
//                               Paid
//                             </span>
//                           </div>
//                         </div>
//                         <p className="mb-0">April 23, 2024, 09:40 am</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="position-relative ps-4">
//                     <div className="mb-2">
//                       <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
//                         <i className="bx bx-check-circle" />
//                       </span>
//                       <div className="ms-2 d-flex flex-wrap gap-2  align-items-center justify-content-between">
//                         <div>
//                           <h5 className="mb-2 text-dark fw-medium fs-15">
//                             4 Order conform by Gaston Lapierre
//                           </h5>
//                           <a
//                             href="#!"
//                             className="badge bg-light text-dark fw-normal  px-2 py-1 fs-13"
//                           >
//                             Order 1
//                           </a>
//                           <a
//                             href="#!"
//                             className="badge bg-light text-dark fw-normal  px-2 py-1 fs-13"
//                           >
//                             Order 2
//                           </a>
//                           <a
//                             href="#!"
//                             className="badge bg-light text-dark fw-normal  px-2 py-1 fs-13"
//                           >
//                             Order 3
//                           </a>
//                           <a
//                             href="#!"
//                             className="badge bg-light text-dark fw-normal  px-2 py-1 fs-13"
//                           >
//                             Order 4
//                           </a>
//                         </div>
//                         <p className="mb-0">April 23, 2024, 09:40 am</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="card bg-light-subtle">
//               <div className="card-body">
//                 <div className="row g-3 g-lg-0">
//                   <div className="col-lg-3 border-end">
//                     <div className="d-flex align-items-center gap-3 justify-content-between px-3">
//                       <div>
//                         <p className="text-dark fw-medium fs-16 mb-1">Vender</p>
//                         <p className="mb-0">Catpiller</p>
//                       </div>
//                       <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
//                         <iconify-icon
//                           icon="solar:shop-2-bold-duotone"
//                           className="fs-35 text-primary"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-3 border-end">
//                     <div className="d-flex align-items-center gap-3 justify-content-between px-3">
//                       <div>
//                         <p className="text-dark fw-medium fs-16 mb-1">Date</p>
//                         <p className="mb-0">April 23 , 2024</p>
//                       </div>
//                       <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
//                         <iconify-icon
//                           icon="solar:calendar-date-bold-duotone"
//                           className="fs-35 text-primary"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-3 border-end">
//                     <div className="d-flex align-items-center gap-3 justify-content-between px-3">
//                       <div>
//                         <p className="text-dark fw-medium fs-16 mb-1">
//                           Paid By
//                         </p>
//                         <p className="mb-0">Gaston Lapierre</p>
//                       </div>
//                       <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
//                         <iconify-icon
//                           icon="solar:user-circle-bold-duotone"
//                           className="fs-35 text-primary"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-3">
//                     <div className="d-flex align-items-center gap-3 justify-content-between px-3">
//                       <div>
//                         <p className="text-dark fw-medium fs-16 mb-1">
//                           Reference #IMEMO
//                         </p>
//                         <p className="mb-0">#0758267/90</p>
//                       </div>
//                       <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
//                         <iconify-icon
//                           icon="solar:clipboard-text-bold-duotone"
//                           className="fs-35 text-primary"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-lg-4">
//         <div className="card">
//           <div className="card-header">
//             <h4 className="card-title">Order Summary</h4>
//           </div>
//           <div className="card-body">
//             <div className="table-responsive">
//               <table className="table mb-0">
//                 <tbody>
//                   <tr>
//                     <td className="px-0">
//                       <p className="d-flex mb-0 align-items-center gap-1">
//                         <iconify-icon icon="solar:clipboard-text-broken" />
//                         Sub Total :
//                       </p>
//                     </td>
//                     <td className="text-end text-dark fw-medium px-0">
//                       $777.00
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="px-0">
//                       <p className="d-flex mb-0 align-items-center gap-1">
//                         <iconify-icon
//                           icon="solar:ticket-broken"
//                           className="align-middle"
//                         />{" "}
//                         Discount :
//                       </p>
//                     </td>
//                     <td className="text-end text-dark fw-medium px-0">
//                       -$60.00
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="px-0">
//                       <p className="d-flex mb-0 align-items-center gap-1">
//                         <iconify-icon
//                           icon="solar:kick-scooter-broken"
//                           className="align-middle"
//                         />{" "}
//                         Delivery Charge :
//                       </p>
//                     </td>
//                     <td className="text-end text-dark fw-medium px-0">
//                       $00.00
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="px-0">
//                       <p className="d-flex mb-0 align-items-center gap-1">
//                         <iconify-icon
//                           icon="solar:calculator-minimalistic-broken"
//                           className="align-middle"
//                         />
//                         Estimated Tax (15.5%) :
//                       </p>
//                     </td>
//                     <td className="text-end text-dark fw-medium px-0">
//                       $20.00
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//           <div className="card-footer d-flex align-items-center justify-content-between bg-light-subtle">
//             <div>
//               <p className="fw-medium text-dark mb-0">Total Amount</p>
//             </div>
//             <div>
//               <p className="fw-medium text-dark mb-0">$737.00</p>
//             </div>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-header">
//             <h4 className="card-title">Payment Information</h4>
//           </div>
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-3 mb-3">
//               <div className="rounded-3 bg-light avatar d-flex align-items-center justify-content-center">
//                 <img
//                   src="/images/card/mastercard.svg"
//                   alt=""
//                   className="avatar-sm"
//                 />
//               </div>
//               <div>
//                 <p className="mb-1 text-dark fw-medium">Master Card</p>
//                 <p className="mb-0 text-dark">xxxx xxxx xxxx 7812</p>
//               </div>
//               <div className="ms-auto">
//                 <iconify-icon
//                   icon="solar:check-circle-broken"
//                   className="fs-22 text-success"
//                 />
//               </div>
//             </div>
//             <p className="text-dark mb-1 fw-medium">
//               Transaction ID :{" "}
//               <span className="text-muted fw-normal fs-13"> #IDN768139059</span>
//             </p>
//             <p className="text-dark mb-0 fw-medium">
//               Card Holder Name :{" "}
//               <span className="text-muted fw-normal fs-13">
//                 {" "}
//                 Gaston Lapierre
//               </span>
//             </p>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-header">
//             <h4 className="card-title">Customer Details</h4>
//           </div>
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-2">
//               <img
//                 src="/images/users/avatar-1.jpg"
//                 alt=""
//                 className="avatar rounded-3 border border-light border-3"
//               />
//               <div>
//                 <p className="mb-1">Gaston Lapierre</p>
//                 <a href="#!" className="link-primary fw-medium">
//                   hello@dundermuffilin.com
//                 </a>
//               </div>
//             </div>
//             <div className="d-flex justify-content-between mt-3">
//               <h5 className="">Contact Number</h5>
//               <div>
//                 <a href="#!">
//                   <i className="bx bx-edit-alt fs-18" />
//                 </a>
//               </div>
//             </div>
//             <p className="mb-1">(723) 732-760-5760</p>
//             <div className="d-flex justify-content-between mt-3">
//               <h5 className="">Shipping Address</h5>
//               <div>
//                 <a href="#!">
//                   <i className="bx bx-edit-alt fs-18" />
//                 </a>
//               </div>
//             </div>
//             <div>
//               <p className="mb-1">Wilson's Jewelers LTD</p>
//               <p className="mb-1">1344 Hershell Hollow Road ,</p>
//               <p className="mb-1">Tukwila, WA 98168 ,</p>
//               <p className="mb-1">United States</p>
//               <p className="">(723) 732-760-5760</p>
//             </div>
//             <div className="d-flex justify-content-between mt-3">
//               <h5 className="">Billing Address</h5>
//               <div>
//                 <a href="#!">
//                   <i className="bx bx-edit-alt fs-18" />
//                 </a>
//               </div>
//             </div>
//             <p className="mb-1">Same as shipping address</p>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-body">
//             <div className="mapouter">
//               <div className="gmap_canvas">
//                 <iframe
//                   className="gmap_iframe rounded"
//                   width="100%"
//                   style={{ height: 418 }}
//                   frameBorder={0}
//                   scrolling="no"
//                   marginHeight={0}
//                   marginWidth={0}
//                   src="https://maps.google.com/maps?width=1980&height=400&hl=en&q=University of Oxford&t=&z=14&ie=UTF8&iwloc=B&output=embed"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>

//   )
// }

// export default OrderDetail

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const OrderDetail = () => {
  const { id } = useParams(); // Get order ID from URL parameter (/order-detail/3)
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchOrderDetails(id);
    }
  }, [id]);

  const fetchOrderDetails = async (orderId) => {
    try {
      setLoading(true);
      setError(null);
      
      // POST request with order_id in body
      const response = await axios.post(
        'https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order',
        { order_id: orderId },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data.status && response.data.data.length > 0) {
        setOrderData(response.data.data[0]);
      } else {
        setError('No order data found');
      }
    } catch (err) {
      setError('Failed to fetch order details');
      console.error('Error fetching order:', err);
    } finally {
      setLoading(false);
    }
  };

  // Helper functions
  const formatCurrency = (amount) => {
    return `$${(amount / 100).toFixed(2)}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const getPaymentStatusBadge = (status) => {
    if (status === 'Pending') {
      return 'badge bg-warning-subtle text-warning px-2 py-1 fs-13';
    }
    return 'badge bg-success-subtle text-success px-2 py-1 fs-13';
  };

  const getOrderStatusBadge = (status) => {
    const statusMap = {
      'Pending': 'border border-warning text-warning',
      'Processing': 'border border-info text-info',
      'Shipped': 'border border-primary text-primary',
      'Delivered': 'border border-success text-success',
      'Cancelled': 'border border-danger text-danger'
    };
    return `${statusMap[status] || 'border border-secondary text-secondary'} fs-13 px-2 py-1 rounded`;
  };

  const getProgressWidth = (status) => {
    const progressMap = {
      'Pending': [100, 0, 0, 0, 0],
      'Processing': [100, 100, 60, 0, 0],
      'Shipped': [100, 100, 100, 60, 0],
      'Delivered': [100, 100, 100, 100, 100]
    };
    return progressMap[status] || [0, 0, 0, 0, 0];
  };

  const getProgressColor = (index, status) => {
    const progressWidths = getProgressWidth(status);
    if (progressWidths[index] === 100) return 'bg-success';
    if (progressWidths[index] > 0) return 'bg-warning';
    return 'bg-primary';
  };

  const calculateSubtotal = (items) => {
    return items.reduce((sum, item) => sum + item.subtotal, 0);
  };

  const calculateTax = (subtotal, taxRate = 15.5) => {
    return (subtotal * taxRate) / 100;
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !orderData) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="alert alert-danger" role="alert">
            {error || 'No order data available'}
          </div>
        </div>
      </div>
    );
  }

  const { items, total, order_status, payment_status, payment_mode, order_date, created_at, 
          order_number, customer_name, phone, contact_address } = orderData;
  
  const subtotal = calculateSubtotal(items);
  const discount = 0;
  const deliveryCharge = 0;
  const tax = calculateTax(subtotal);
  const totalAmount = subtotal - discount + deliveryCharge + tax;
  const progressWidths = getProgressWidth(order_status);

  return (
    <div className="page-content">
      {/* Start Container */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Order Details</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Order</a>
                </li>
                <li className="breadcrumb-item active">Order Details</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                      <div>
                        <h4 className="fw-medium text-dark d-flex align-items-center gap-2">
                          {order_number}{" "}
                          <span className={getPaymentStatusBadge(payment_status)}>
                            {payment_status}
                          </span>
                          <span className={getOrderStatusBadge(order_status)}>
                            {order_status}
                          </span>
                        </h4>
                        <p className="mb-0">
                          Order / Order Details / {order_number} - {formatDate(created_at)} at{" "}
                          {formatTime(created_at)}
                        </p>
                      </div>
                      <div>
                        <a href="#!" className="btn btn-outline-secondary">
                          Refund
                        </a>
                        <a href="#!" className="btn btn-outline-secondary">
                          Return
                        </a>
                        <a href="#!" className="btn btn-primary">
                          Edit Order
                        </a>
                      </div>
                    </div>
                    <div className="mt-4">
                      <h4 className="fw-medium text-dark">Progress</h4>
                    </div>
                    <div className="row row-cols-xxl-5 row-cols-md-2 row-cols-1">
                      <div className="col">
                        <div className="progress mt-3" style={{ height: 10 }}>
                          <div
                            className={`progress-bar progress-bar progress-bar-striped progress-bar-animated ${getProgressColor(0, order_status)}`}
                            role="progressbar"
                            style={{ width: `${progressWidths[0]}%` }}
                            aria-valuenow={progressWidths[0]}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          ></div>
                        </div>
                        <p className="mb-0 mt-2">Order Confirming</p>
                      </div>
                      <div className="col">
                        <div className="progress mt-3" style={{ height: 10 }}>
                          <div
                            className={`progress-bar progress-bar progress-bar-striped progress-bar-animated ${getProgressColor(1, order_status)}`}
                            role="progressbar"
                            style={{ width: `${progressWidths[1]}%` }}
                            aria-valuenow={progressWidths[1]}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          ></div>
                        </div>
                        <p className="mb-0 mt-2">Payment {payment_status}</p>
                      </div>
                      <div className="col">
                        <div className="progress mt-3" style={{ height: 10 }}>
                          <div
                            className={`progress-bar progress-bar progress-bar-striped progress-bar-animated ${getProgressColor(2, order_status)}`}
                            role="progressbar"
                            style={{ width: `${progressWidths[2]}%` }}
                            aria-valuenow={progressWidths[2]}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          ></div>
                        </div>
                        <div className="d-flex align-items-center gap-2 mt-2">
                          <p className="mb-0">Processing</p>
                          {order_status === 'Processing' && (
                            <div
                              className="spinner-border spinner-border-sm text-warning"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <div className="progress mt-3" style={{ height: 10 }}>
                          <div
                            className={`progress-bar progress-bar progress-bar-striped progress-bar-animated ${getProgressColor(3, order_status)}`}
                            role="progressbar"
                            style={{ width: `${progressWidths[3]}%` }}
                            aria-valuenow={progressWidths[3]}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          ></div>
                        </div>
                        <p className="mb-0 mt-2">Shipping</p>
                      </div>
                      <div className="col">
                        <div className="progress mt-3" style={{ height: 10 }}>
                          <div
                            className={`progress-bar progress-bar progress-bar-striped progress-bar-animated ${getProgressColor(4, order_status)}`}
                            role="progressbar"
                            style={{ width: `${progressWidths[4]}%` }}
                            aria-valuenow={progressWidths[4]}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          ></div>
                        </div>
                        <p className="mb-0 mt-2">Delivered</p>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-flex flex-wrap align-items-center justify-content-between bg-light-subtle gap-2">
                    <p className="border rounded mb-0 px-2 py-1 bg-body">
                      <i className="bx bx-arrow-from-right align-middle fs-16" />
                      Estimated shipping date :{" "}
                      <span className="text-dark fw-medium">
                        {formatDate(new Date(new Date(order_date).getTime() + 2 * 24 * 60 * 60 * 1000))}
                      </span>
                    </p>
                    <div>
                      <a href="#!" className="btn btn-primary">
                        Make As Ready To Ship
                      </a>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Product</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table align-middle mb-0 table-hover table-centered">
                        <thead className="bg-light-subtle border-bottom">
                          <tr>
                            <th>Product Name &amp; Size</th>
                            <th>Status</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Tax</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                    <img
                                      src={`https://cyberathon.com/multivendor/${item.multi_image}`}
                                      alt={item.product_name}
                                      className="avatar-md"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = '/images/product/placeholder.png';
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <a
                                      href="#!"
                                      className="text-dark fw-medium fs-15"
                                    >
                                      {item.product_name}
                                    </a>
                                    <p className="text-muted mb-0 mt-1 fs-13">
                                      <span>Size: </span>{item.size}
                                      <span className="ms-2">Color: </span>{item.color}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-success-subtle text-success px-2 py-1 fs-13">
                                  Ready
                                </span>
                              </td>
                              <td>{item.qty}</td>
                              <td>{formatCurrency(item.price)}</td>
                              <td>{formatCurrency(0)}</td>
                              <td>{formatCurrency(item.subtotal)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Order Timeline</h4>
                  </div>
                  <div className="card-body">
                    <div className="position-relative ms-2">
                      <span className="position-absolute start-0 top-0 border border-dashed h-100" />
                      
                      {order_status === 'Processing' && (
                        <div className="position-relative ps-4">
                          <div className="mb-4">
                            <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle">
                              <div
                                className="spinner-border spinner-border-sm text-warning"
                                role="status"
                              >
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </span>
                            <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
                              <div>
                                <h5 className="mb-1 text-dark fw-medium fs-15">
                                  The packing has been started
                                </h5>
                                <p className="mb-0">Confirmed by {customer_name}</p>
                              </div>
                              <p className="mb-0">{formatDate(created_at)}, {formatTime(created_at)}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      
                      <div className="position-relative ps-4">
                        <div className="mb-4">
                          <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
                            <i className="bx bx-check-circle" />
                          </span>
                          <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-1 text-dark fw-medium fs-15">
                                Order Payment
                              </h5>
                              <p className="mb-2">Using {payment_mode}</p>
                              <div className="d-flex align-items-center gap-2">
                                <p className="mb-1 text-dark fw-medium">Status :</p>
                                <span className={getPaymentStatusBadge(payment_status)}>
                                  {payment_status}
                                </span>
                              </div>
                            </div>
                            <p className="mb-0">{formatDate(created_at)}, {formatTime(created_at)}</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="position-relative ps-4">
                        <div className="mb-2">
                          <span className="position-absolute start-0 avatar-sm translate-middle-x bg-light d-inline-flex align-items-center justify-content-center rounded-circle text-success fs-20">
                            <i className="bx bx-check-circle" />
                          </span>
                          <div className="ms-2 d-flex flex-wrap gap-2 align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-2 text-dark fw-medium fs-15">
                                {items.length} Order confirmed by {customer_name}
                              </h5>
                              {items.map((item, index) => (
                                <a
                                  key={index}
                                  href="#!"
                                  className="badge bg-light text-dark fw-normal px-2 py-1 fs-13 me-1"
                                >
                                  {item.product_name}
                                </a>
                              ))}
                            </div>
                            <p className="mb-0">{formatDate(created_at)}, {formatTime(created_at)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card bg-light-subtle">
                  <div className="card-body">
                    <div className="row g-3 g-lg-0">
                      <div className="col-lg-3 border-end">
                        <div className="d-flex align-items-center gap-3 justify-content-between px-3">
                          <div>
                            <p className="text-dark fw-medium fs-16 mb-1">Order Number</p>
                            <p className="mb-0">{order_number}</p>
                          </div>
                          <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
                            <iconify-icon
                              icon="solar:shop-2-bold-duotone"
                              className="fs-35 text-primary"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 border-end">
                        <div className="d-flex align-items-center gap-3 justify-content-between px-3">
                          <div>
                            <p className="text-dark fw-medium fs-16 mb-1">Date</p>
                            <p className="mb-0">{formatDate(order_date)}</p>
                          </div>
                          <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
                            <iconify-icon
                              icon="solar:calendar-date-bold-duotone"
                              className="fs-35 text-primary"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 border-end">
                        <div className="d-flex align-items-center gap-3 justify-content-between px-3">
                          <div>
                            <p className="text-dark fw-medium fs-16 mb-1">
                              Paid By
                            </p>
                            <p className="mb-0">{customer_name}</p>
                          </div>
                          <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
                            <iconify-icon
                              icon="solar:user-circle-bold-duotone"
                              className="fs-35 text-primary"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center gap-3 justify-content-between px-3">
                          <div>
                            <p className="text-dark fw-medium fs-16 mb-1">
                              Payment Mode
                            </p>
                            <p className="mb-0">{payment_mode}</p>
                          </div>
                          <div className="avatar bg-light d-flex align-items-center justify-content-center rounded">
                            <iconify-icon
                              icon="solar:clipboard-text-bold-duotone"
                              className="fs-35 text-primary"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Order Summary</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table mb-0">
                    <tbody>
                      <tr>
                        <td className="px-0">
                          <p className="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon icon="solar:clipboard-text-broken" />
                            Sub Total :
                          </p>
                        </td>
                        <td className="text-end text-dark fw-medium px-0">
                          {formatCurrency(subtotal)}
                        </td>
                      </tr>
                      <tr>
                        <td className="px-0">
                          <p className="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:ticket-broken"
                              className="align-middle"
                            />{" "}
                            Discount :
                          </p>
                        </td>
                        <td className="text-end text-dark fw-medium px-0">
                          -{formatCurrency(discount)}
                        </td>
                      </tr>
                      <tr>
                        <td className="px-0">
                          <p className="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:kick-scooter-broken"
                              className="align-middle"
                            />{" "}
                            Delivery Charge :
                          </p>
                        </td>
                        <td className="text-end text-dark fw-medium px-0">
                          {formatCurrency(deliveryCharge)}
                        </td>
                      </tr>
                      <tr>
                        <td className="px-0">
                          <p className="d-flex mb-0 align-items-center gap-1">
                            <iconify-icon
                              icon="solar:calculator-minimalistic-broken"
                              className="align-middle"
                            />
                            Estimated Tax (15.5%) :
                          </p>
                        </td>
                        <td className="text-end text-dark fw-medium px-0">
                          {formatCurrency(tax)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer d-flex align-items-center justify-content-between bg-light-subtle">
                <div>
                  <p className="fw-medium text-dark mb-0">Total Amount</p>
                </div>
                <div>
                  <p className="fw-medium text-dark mb-0">{formatCurrency(totalAmount)}</p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Payment Information</h4>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="rounded-3 bg-light avatar d-flex align-items-center justify-content-center">
                    <img
                      src={payment_mode === 'Cash' ? '/images/card/cash.svg' : '/images/card/mastercard.svg'}
                      alt=""
                      className="avatar-sm"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                  <div>
                    <p className="mb-1 text-dark fw-medium">{payment_mode}</p>
                    <p className="mb-0 text-dark">
                      {payment_mode === 'Cash' ? 'Cash on Delivery' : 'xxxx xxxx xxxx 7812'}
                    </p>
                  </div>
                  <div className="ms-auto">
                    <iconify-icon
                      icon="solar:check-circle-broken"
                      className={`fs-22 ${payment_status === 'Paid' ? 'text-success' : 'text-warning'}`}
                    />
                  </div>
                </div>
                <p className="text-dark mb-1 fw-medium">
                  Transaction ID :{" "}
                  <span className="text-muted fw-normal fs-13"> #{order_number}</span>
                </p>
                <p className="text-dark mb-0 fw-medium">
                  Card Holder Name :{" "}
                  <span className="text-muted fw-normal fs-13">
                    {" "}
                    {customer_name}
                  </span>
                </p>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Customer Details</h4>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <img
                    src="/images/users/avatar-1.jpg"
                    alt=""
                    className="avatar rounded-3 border border-light border-3"
                  />
                  <div>
                    <p className="mb-1">{customer_name}</p>
                    <a href="#!" className="link-primary fw-medium">
                      Contact Customer
                    </a>
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <h5 className="">Contact Number</h5>
                  <div>
                    <a href="#!">
                      <i className="bx bx-edit-alt fs-18" />
                    </a>
                  </div>
                </div>
                <p className="mb-1">{phone}</p>
                <div className="d-flex justify-content-between mt-3">
                  <h5 className="">Shipping Address</h5>
                  <div>
                    <a href="#!">
                      <i className="bx bx-edit-alt fs-18" />
                    </a>
                  </div>
                </div>
                <div>
                  <p className="mb-1">{contact_address}</p>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <h5 className="">Billing Address</h5>
                  <div>
                    <a href="#!">
                      <i className="bx bx-edit-alt fs-18" />
                    </a>
                  </div>
                </div>
                <p className="mb-1">Same as shipping address</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="mapouter">
                  <div className="gmap_canvas">
                    <iframe
                      className="gmap_iframe rounded"
                      width="100%"
                      style={{ height: 418 }}
                      frameBorder={0}
                      scrolling="no"
                      marginHeight={0}
                      marginWidth={0}
                      src="https://maps.google.com/maps?width=1980&height=400&hl=en&q=Nagpur,+Maharashtra&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
